<template>
  <div>
    <div ref="recaptchaContainer"></div>
    <el-button
      class="mr-2"
      :title="title"
      :loading="loading"
      color="primary"
      icon="plus"
      @click.native.stop="verify()"
    />
  </div>
</template>

<script>
export default {
  name: 'DRecaptcha',
  props: {
    title: String,
    loading: Boolean,
  },
  data() {
    return {
      active: false,
      sitekey: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY,
    }
  },
  mounted() {
    const scriptUrl = `https://www.google.com/recaptcha/api.js?render=${this.sitekey}`

    // Check if already exists
    if (!this.scriptExists(scriptUrl)) {
      const script = document.createElement('script')
      script.src = scriptUrl
      document.head.appendChild(script)
    }
  },
  methods: {
    renderRecaptcha() {
      const siteKey = this.sitekey
      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey, { action: 'submit' }).then((token) => {
          // Handle the verified token
          this.$emit('verifyData', token)
        })
      })
    },
    verify() {
      this.renderRecaptcha()
    },
    scriptExists(src) {
      const scripts = document.getElementsByTagName('script')
      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src === src) {
          return true
        }
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
